import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { AbstractControl, FormControl, FormGroup, Validators } from "@angular/forms";
import { IonContent, LoadingController, NavParams, PopoverController } from "@ionic/angular";
import { Navigator } from "src/app/components/menu/navigator";
import { DepositMainLabels } from "src/app/interfaces/deposit-main-labels";
import { VipPreferredModel } from "src/app/models/deposit-models";

import { AddressService } from "src/app/services/address/address.service";
import { AppLinksService } from "src/app/services/applinks/app-links.service";
import { AuthenticationService } from "src/app/services/authentication/authentication.service";
import { AccountBalanceService } from "src/app/services/balance/account-balance.service";
import { BannerService } from "src/app/services/banner/banner.service";
import { CashierContentService } from "src/app/services/cashier/cashier-content.service";
import { CashierService } from "src/app/services/cashier/cashier.service";
import { ConfigService } from "src/app/services/config/config.service";
import { DEPOSIT_PATTERN, idNumberGroupMatchValidator, ID_PATTERN } from "src/app/services/customFormValidators";
import { EventsService } from "src/app/services/event/event.service";
import { SuccessMessageService } from "src/app/services/message-provider/success-message.service";
import { UserSessionService } from "src/app/services/user-session/user-session.service";
import { UtilsService } from "src/app/services/utils/utils.service";
import { CashierBase } from "../../cashier-base/cashier-base";
import { TimeService } from "src/app/services/time-service/time.service";

import { first } from 'rxjs/operators';
import { isUndefined } from "src/app/services/codeUtils";
import { AffiliateTrackerCallbackParams } from "src/app/interfaces/affliation-interface";

@Component({
	selector: 'app-deposit-vip',
  	templateUrl: './deposit-vip.component.html',
  	styleUrls: ['./deposit-vip.component.scss'],
})

export class DepositVipComponent extends CashierBase implements OnInit{

	@ViewChild(IonContent, { static: false }) content: IonContent;
	@Input() public navigateBackPage: any;


	public depositForm: FormGroup;
	public accountNumber: AbstractControl;
  	public accountList: AbstractControl;
	public amount: AbstractControl;
	public idType: AbstractControl;
	public idNumberGroup: AbstractControl;
	public idNumber: AbstractControl;
	public idNumber2: AbstractControl;
	public idState: AbstractControl;
	public routingNumber: AbstractControl;

	public accounts: Array<any> = [];
	public bonusCode: string;
	public buttonDisabled: boolean = false;
	public defaultAmounts: any = [];
	public error = null;
	public infoCheckImage: any;
	public isEnrolled: boolean = false;
	public labels: DepositMainLabels;
	public minAmount: any;
	public maxVIPAccounts: number;
	public paymentType: any = [];
	public selectedAccount: any;
	public selectedProvince: string;
	public showInfoPopover: boolean;
	public states : any = [];
	public uiState;
	public UIStates = ['enroll', 'add', 'deposit'];
	
	public loading: any
	
	constructor(
		public accountBalanceService: AccountBalanceService,
		public addressService: AddressService,
		public appLinksService: AppLinksService,
		public authenticationService: AuthenticationService,
		public bannerService: BannerService,
		public cashierService: CashierService,
		public cashierContentService: CashierContentService,
		public config: ConfigService,
		public events: EventsService,
		public navigator: Navigator,
		public navParams:NavParams,
		public popoverController: PopoverController,
		public successMessageService: SuccessMessageService,
		public utils: UtilsService,
		public userSessionService: UserSessionService,
		public timeService: TimeService,
		public loadingController: LoadingController
	){
		super();
		this.successMessageService.clearMessage();
		this.labels = new VipPreferredModel();

		this.infoCheckImage = this.utils.getCDNAsset("images/check_image.png");
	}

	async showLoading() {
		this.loading = await this.loadingController.create({
		  message: 'Loading...',
		  duration: 3000
		});
	  
		this.loading.present();
	  }

	ngOnInit(): void {

        this.buttonDisabled = false;
        this.maxVIPAccounts = this.config.getConfig().FEATURE_VIP_ACH_NUM_ACCTS ?? 3;


		this.depositForm = new FormGroup(
            {
                amount: new FormControl('', {
                    validators: [Validators.pattern(DEPOSIT_PATTERN), Validators.required],
                    updateOn: 'change'
                }),
                idType: new FormControl('', [Validators.required]),
                idNumberGroup: new FormGroup({
                    idNumber: new FormControl('', [Validators.required, Validators.pattern(ID_PATTERN)]),
                    idNumber2: new FormControl('', [Validators.required, Validators.pattern(ID_PATTERN)]),
                }, idNumberGroupMatchValidator),
                idState: new FormControl('', [Validators.required]),
                routingNumber: new FormControl('', [Validators.required, Validators.minLength(1), Validators.maxLength(9), Validators.pattern('^[0-9]*')]),
                accountNumber: new FormControl('', [Validators.required, Validators.minLength(1), Validators.maxLength(17), Validators.pattern('^[0-9]*')]),
                accountList: new FormControl('', [Validators.required]),
            }
        );

		this.amount = this.depositForm.get('amount');
        this.idType = this.depositForm.get('idType');
        this.idNumberGroup = this.depositForm.get('idNumberGroup');
        this.idNumber = this.idNumberGroup.get('idNumber');
        this.idNumber2 = this.idNumberGroup.get('idNumber2');
        this.idState = this.depositForm.get('idState');
        this.routingNumber = this.depositForm.get('routingNumber');
        this.accountNumber = this.depositForm.get('accountNumber');

        this.accountList = this.depositForm.get('accountList');

		this.getStates();
		this.getAccounts();
		this.getExternalAccounts();

		this.cashierContentService.bonusOfferValue.subscribe(res => this.bonusCode = res);
	}

	ngAfterViewInit(): void {
		this.cashierContentService.getPageConfig('vippreferred').then((response: DepositMainLabels) => {
		  this.labels = response;
		});
	}

	ionViewDidEnter() {
		this.successMessageService.clearMessage();
		this.cashierService.getActivePaymentTypes('CREDIT').subscribe((response: any) => {
		  if (response.result) {
			this.paymentType = response.payload;
			if (this.paymentType.length > 1) {
			  this.minAmount = this.paymentType[0].min;
			  this.defaultAmounts = this.cashierContentService.getDefaultPayments(this.paymentType, 0);
			}
		  }
		}, (error) => console.error("Type category error", error));
	}
	
	public onAmountSelected(data) {
		return this.depositForm.get('amount').setValue(data);
	}

	public selectedDepositBonusOffer($event): void {
		this.bonusCode = $event.selectedbonusOffer.campaign_code;
	}

	private getAccounts(){
		this.cashierService.callListAccounts().pipe(first()).subscribe((response: any) => {
			if (response && !!response.result) {
				this.accounts = response.payload.filter(account => account.paymentTypeCode === 'GP').map((account, key) => {
					account.id = key;
					return account;
				});

				if (this.accounts.length) {
					this.selectedAccount = this.accounts[0].id;
					this.isEnrolled = true;
					this.setUiState();
				}
			}

		}, error => {
			this.error = this.handleError(error);
			this.content.scrollToTop(10);
		});
	}

	private getExternalAccounts(){
		this.cashierService.callVIPExternalAccounts().pipe(first()).subscribe((response: any) => {
			if (response && !!response.result) {
				if( 'accounts' in response.payload ) {
					let externalAccounts = response.payload.accounts;
					let accounts = [];
					let i = 0;

					for (const  key in externalAccounts) {
						let account = externalAccounts[key];
						let data = {
							id: i,
							key: key,
							accountInfo:  account.accountNumber,
							routingNumber: account.routingNumber,
							remainingBalance: account.remainingBalance,
							bankName:         account.bankName,
							accountNumber: account.accountNumber
						}
						accounts.push(data);
						i++;
					}
					this.accounts = accounts;
					this.selectedAccount = this.accounts[0].id;
					this.isEnrolled = true;
					this.setUiState();
				} else {
					this.isEnrolled = false;
					this.setUiState();
				}
			} else {
				this.isEnrolled = false;
				this.setUiState();
			}
		}, error => {
			this.content.scrollToTop(10);
			this.error = error;
			this.error = this.handleError(error);
			this.isEnrolled = false;
			this.setUiState();
		});
	}

	private getStates(){
		this.addressService.callGetStatesByCountry('USA').subscribe((response: any) => {
			if (response && !!response.result){
				let states = response.payload;
				for (let p in states) {
					this.states.push({ code: p, name: states[p] })
				}
				this.selectedProvince = "";
			}
		}, error => {
			this.content.scrollToTop(10);
			this.error = this.handleError(error);
		});
	}

	private setUiState(uiState?: any): any{
        this.uiState = ( !this.isEnrolled ) ? "enroll" : "deposit";
        this.uiState = ( !isUndefined(uiState) ) ? uiState : this.uiState;

		if( this.uiState == "deposit") {
			this.depositForm.removeControl("idType");
			this.depositForm.removeControl("idNumberGroup");
			this.depositForm.removeControl("idState");
			this.depositForm.removeControl("routingNumber");
			this.depositForm.removeControl("accountNumber");
			this.depositForm.addControl("accountList", this.accountList);
			this.depositForm.get("accountList").setValidators([Validators.required]);
			return;
		}

		if( this.uiState == "add") {
            this.depositForm.addControl("idType", this.idType);
            this.depositForm.addControl("idNumberGroup", this.idNumberGroup);
            this.depositForm.addControl("idState", this.idState);
            this.depositForm.addControl("routingNumber", this.routingNumber);
            this.depositForm.addControl("accountNumber", this.accountNumber);
            this.depositForm.get("routingNumber").setValidators([Validators.required, Validators.minLength(1), Validators.maxLength(9), Validators.pattern('^[0-9]*')]);
            this.depositForm.get("accountNumber").setValidators([Validators.required, Validators.minLength(1), Validators.maxLength(17), Validators.pattern('^[0-9]*')]);
            this.depositForm.get("routingNumber").setValue("");
            this.depositForm.get("accountNumber").setValue("");
            this.depositForm.get("accountNumber").markAsPristine();
            this.depositForm.get("accountNumber").markAsUntouched();
            this.depositForm.get("routingNumber").markAsPristine();
            this.depositForm.get("routingNumber").markAsUntouched();
			return;
        }

		if( this.uiState == "enroll") {
            this.depositForm.addControl("accountList", this.accountList);
            this.depositForm.addControl("idType", this.idType);
            this.depositForm.addControl("idNumberGroup", this.idNumberGroup);
            this.depositForm.addControl("idState", this.idState);
            this.depositForm.addControl("routingNumber", this.routingNumber);
            this.depositForm.addControl("accountNumber", this.accountNumber);
            this.depositForm.removeControl("accountList");
			return;
        }
	}

	public radioChangedCard(e) {
		if (e.target.value == 'diff') return this.onUseDifferentAccount();
		return this.onUseExistingAccount();
	}

	public onUseDifferentAccount(): void {
        this.setUiState("add");
    }

    public onUseExistingAccount(): void {
        this.setUiState("deposit");
    }

	public onSubmit(){
		if (this.uiState == "deposit") return this.onDeposit();
		return this.onAddAccount();
	}

	private onAddAccount(): void{
        this.successMessageService.clearMessage();
        this.error = null;
		this.buttonDisabled = true;
		let formObject: any = this.depositForm.value;

		this.cashierService.AddVipAcccount(formObject).subscribe((response: any) => {
			if(response && !!response.result){
				if (response.payload != null){
					let addAccountData: any = {
						customerAccountID: response.payload.customerAccountID,
						vipCardNumber: response.payload.vipCardNumber,
					}
					this.onDeposit(addAccountData);
				}
			}
			this.buttonDisabled = false;
		}, error => {
			this.content.scrollToTop(10);
			this.buttonDisabled = false;
			this.error = this.handleError(error);
		});

		this.error = null;
	}

	private onDeposit(addAccountData: any = null): void{
        if (!this.didAcknowledgeVipTC()) return this.acknowledgeVipTC();
		this.showLoading();
		this.buttonDisabled = true;
		this.content.scrollToTop(10);
		this.successMessageService.clearMessage();
		this.error = null;

		let depositFormObj: any = this.depositForm.value;
		depositFormObj.amount = this.depositForm.get('amount').value;
		depositFormObj.bonusCode = this.bonusCode;
		depositFormObj.payment_type_code = "GP";
		depositFormObj.currency_code = this.cashierService.customer.preferredCurrency.currencyCode;

		if(addAccountData != null) {
			depositFormObj.customerAccountID = addAccountData.customerAccountID;
		} else {
			let accountIndex: any = (this.depositForm.get("accountList") != null && this.depositForm.get("accountList").value != null ) ? this.depositForm.get("accountList").value : "0";
			if('customerAccountID' in  this.accounts[accountIndex]) depositFormObj.customerAccountID = this.accounts[accountIndex].customerAccountID;
			depositFormObj.key = this.accounts[accountIndex].key;
		}

		this.cashierService.callDeposit(depositFormObj).subscribe((response: any) => {			
			if (response && !!response.result) {
				/*let depositEventData: AffiliateTrackerCallbackParams = {
					customer_id: this.cashierService.customer.customerId,
					amount:     depositFormObj.amount,
					transaction_id: response.payload.paymentRequestID,
					paymentMethod: "VIP_PREFERRED"
				}

				setTimeout(() => this.events.publish('event:deposit', depositEventData), 2000);*/
				setTimeout(() => this.bannerService.fetchAllBanners(), 1000);
				setTimeout(() => this.accountBalanceService.updateBalance(), 1000);

				let exceededDepositLimit = false;
				this.loading.dismiss();
				if ('hasExceededDepositLimit' in response.payload) {
					exceededDepositLimit = response.payload.hasExceededDepositLimit;
				}

				if (exceededDepositLimit) {
					return this.navigator.navigateTo('DepositThresholdComponent', {}, { status: true, amount: this.depositForm.get('amount').value, customerId: this.cashierService.customer.customerId });
				} else {
					this.buttonDisabled = false;
					return this.navigator.navigateTo("DepositSuccessFailureComponent", {}, { status: true, message: '$' + this.amount.value + " has been added to your account."});
				}

			}else{
				this.loading.dismiss();
				return this.navigator.navigateTo("DepositSuccessFailureComponent", {}, { status: false, navigateBackPage: "CashierVipPage", message: 'Please Contact Support'});
			}

		}, error => {
			this.buttonDisabled = false;
			this.error = this.handleError(error);
			this.loading.dismiss();
			this.navigator.navigateTo("DepositSuccessFailureComponent", {}, { status: false, navigateBackPage: "CashierVipPage", message: this.error.error_message});
		});

		this.error = null;
	}


	public didAcknowledgeVipTC() {
        let customer = this.cashierService.customer;
        if (customer && customer.customData) {
            let customData = customer.customData;
            if( "undefined" !== typeof customData && customData) {
                let acknowledgeVipTC = customer.getCustomDataProperty("ACKNOWLEDGE_VIP_TC")
                if(!!acknowledgeVipTC) {
                    return true;
                }

            }
        }
        return false;
    }

	public acknowledgeVipTC(){

        const popoverComp = 'VipTermsComponent';

        let link = {
            url: this.config.getConfig().FEATURE_GLOBALPAY_TOC,
            text: "Terms & Conditions",
        };

        let data: any = {
            content: "Please click on the Terms & Conditions link before proceeding with the deposit ",
            link: link,
            title: "Terms & Conditions",
            expectResult: true,
            onClosePopup: this.closePopup,
            onCloseFunc: this.depositVipConfirmed
        };

		this.navigator.openPopover(popoverComp, data);
	}

	public closePopup = () => {
        this.buttonDisabled = false;
    } 

    public depositVipConfirmed = () => {		
		this.timeService.getServerTime().then((serverTime:any) => {
			let date_string = new Date().toUTCString();
			if (serverTime.result == 1) {
				date_string = serverTime.payload.full.replace(' EST', '');;
			}

			let data: any = [];
			data['propName'] = "ACKNOWLEDGE_VIP_TC";
			data['propValue'] = date_string;
			this.authenticationService.updateCustomData(data).subscribe(() => {
					this.userSessionService.refreshCustomer();
				}
			);

		});

        this.buttonDisabled = false;
    }

	public showTOC(){
		let url = this.config.getConfig().FEATURE_GLOBALPAY_TOC ?? '';
		return this.appLinksService.openExternalPage(url);
	}

	public dismissInfoPopover(){
		return this.popoverController.dismiss();
	}

	onBack = () => {
		this.cashierContentService.onBackHandler(this.navigateBackPage);
	}

}